module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-button', {
    staticClass: "sl-el-btn",
    class: {
      className: _vm.className, 'sl-disabled': _vm.disabled
    },
    attrs: {
      "icon": _vm.icon,
      "loading": _vm.loading,
      "disabled": _vm.disabled
    }
  }, [_vm._v(_vm._s(_vm.text))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0a1d2f72!./~/vue-loader/lib/selector.js?type=template&index=0!./src/includes/sl-btn.vue
// module id = 1080
// module chunks = 1